import { createAction } from 'redux-actions';
export const SET_GDS_SERVICES_REFUND_INFO = 'REFUND/SET_GDS_SERVICES_REFUND_INFO ';
export const setGdsServicesRefundInfo = createAction(SET_GDS_SERVICES_REFUND_INFO);
